import { Loader } from '@googlemaps/js-api-loader';
import { MarkerClusterer, SuperClusterAlgorithm } from '@googlemaps/markerclusterer';

const mapElement = document.querySelector('#participation-map');

if (mapElement) {
    const loader = new Loader({
        apiKey: 'AIzaSyBfR0-eZxmSLsDH9sE5bwBD6zeN4nqXJgg',
        version: 'weekly',
        region: "GB"
    });

    loader.load().then(async google => {
        'use strict';

        const {Map} = await google.maps.importLibrary('maps');
        const {AdvancedMarkerElement} = await google.maps.importLibrary('marker');
        const {Geocoder} = await google.maps.importLibrary('geocoding');

        let center = new google.maps.LatLng(54.6320103, -4.5117084);
        let bounds;

        // If a country is chosen, update the center and bounds to match
        const country = mapElement.dataset.country;
        if (country) {
            const geocoder = new Geocoder();
            await geocoder.geocode({address: country}, results => {
                center = results[0].geometry.location;
                bounds = results[0].geometry.viewport;
                return results;
            });
        }

        // Create map
        const map = new Map(mapElement, {
            mapId: 'ce47c86dd4e6fe75',
            zoom: 6,
            center: center,
            mapTypeControl: false,
            streetViewControl: false,
            zoomControlOptions: {
                position: google.maps.ControlPosition.TOP_LEFT
            }
        });

        // Reset map center on window resize
        google.maps.event.addDomListener(window, 'resize', () => map.setCenter(center));

        // Zoom to show the chosen country if bounds are set
        if (bounds) {
            map.fitBounds(bounds);
        }

        const pinJson = window.mapJson;

        // If we successfully retrieve pins then plot and cluster them
        if (pinJson) {
            // Generate HTML content for a school popup
            const buildContent = (school) => {
                const content = document.createElement('div');
                content.classList.add('school');
                content.innerHTML = `
                    <button type="button" class="close-btn" aria-label="Close this popup"><img src="${window.mapImages.closeBtn}" alt="Close"></button>
                    <div class="icon">
                        <img src="${window.mapImages.marker}" alt="${school.n}">
                    </div>
                    <div class="details">
                        <h5 class="name">${school.n}</h5>
                        <div class="address">
                            <h6>Address</h6>
                            <p>${school.l.a}</p>
                        </div>
                    </div>
                `;
                return content;
            };

            // Render custom cluster icons
            const customRenderer = {
                render: function ({count, position}) {
                    return new google.maps.Marker({
                        position,
                        icon: {
                            url: window.mapImages.clusterMarker,
                            scaledSize: new google.maps.Size(90, 35),
                        },
                        label: {
                            text: String(count) + ' schools',
                            className: 'cluster-label'
                        },
                        zIndex: 1000 + count,
                    });

                }
            };

            const markers = pinJson.map(school => {
                // Create marker
                const marker = new AdvancedMarkerElement({
                    map,
                    content: buildContent(school),
                    position: new google.maps.LatLng(school.l.la, school.l.ln),
                    title: school.n,
                    gmpClickable: true,
                });

                // Open modal on marker click, close on close button click
                marker.addListener('click', e => {
                    if (marker.content.classList.contains('active')) {
                        const target = e.domEvent.target;
                        if (target.classList.contains('close-btn') || target.parentElement.classList.contains('close-btn')) {
                            marker.content.classList.remove('active');
                            marker.zIndex = null;
                        }
                    } else {
                        marker.content.classList.add('active');
                        marker.zIndex = 1;
                    }
                });

                return marker;
            });

            // Create clusters
            const markerCluster = new MarkerClusterer({
                map: map,
                markers: markers,
                algorithm: new SuperClusterAlgorithm({minPoints: 7, radius: 20, extent: 90, maxZoom: 18}),
                renderer: customRenderer,
            });
            google.maps.event.addListener(markerCluster, 'clusteringend', () => {
                mapElement.classList.add('loaded');
            });
        }
    });
}
